import { Button } from "@/components/ui/button";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle2, FileText, User, Briefcase } from "lucide-react";

interface WelcomeStepProps {
  job: {
    title: string;
    company: string;
  };
  onNext: () => void;
}

export const WelcomeStep = ({ job, onNext }: WelcomeStepProps) => {
  return (
    <>
      <CardHeader className="text-center pb-4">
        <div className="mb-4">
          <p className="text-sm text-muted-foreground mb-2">You are applying for:</p>
          <CardTitle className="text-2xl md:text-3xl mb-2">{job.title}</CardTitle>
          <p className="text-lg text-primary font-semibold">at {job.company}</p>
        </div>
      </CardHeader>

      <CardContent className="space-y-6 pb-8">
        <div className="bg-primary/5 p-6 rounded-lg border border-primary/10">
          <h3 className="font-semibold text-lg mb-2">Let's get your application ready</h3>
          <p className="text-muted-foreground">
            This should only take about <span className="font-semibold text-foreground">5 minutes</span>. 
            We'll guide you through each step.
          </p>
        </div>

        <div>
          <h4 className="font-semibold mb-3 flex items-center gap-2">
            <Briefcase className="h-5 w-5 text-primary" />
            What you'll need:
          </h4>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <CheckCircle2 className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
              <span className="text-muted-foreground">Your contact details</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
              <span className="text-muted-foreground">
                A CV/resume or a summary of your work experience
              </span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
              <span className="text-muted-foreground">
                A few sentences about why you're interested
              </span>
            </li>
          </ul>
        </div>

        <div className="bg-accent/5 p-4 rounded-lg border border-accent/10">
          <p className="text-sm text-muted-foreground">
            💡 <span className="font-semibold text-foreground">Tip:</span> You can save your progress 
            and come back later if you need more time.
          </p>
        </div>

        <Button onClick={onNext} size="lg" className="w-full">
          Start Application
        </Button>
      </CardContent>
    </>
  );
};
